import React from 'react'
import OrderInfoHeader from './OrderInfoHeader/OrderInfoHeader'
import OrderInfoListing from './OrderInfoListing/OrderInfoListing'

const OrderInfo = () => {
    return (
        <>
            <OrderInfoHeader />
            <OrderInfoListing />
        </>
    )
}

export default OrderInfo